import { useCallback, useEffect, useRef } from 'react';

/**
 * AbortController helper for Subscription tab fetches.
 * Aborts the previous in-flight request when a new one starts, and on unmount.
 */
export function useAbortableRequest() {
  const controllerRef = useRef<AbortController | null>(null);

  const start = useCallback(() => {
    controllerRef.current?.abort();
    const controller = new AbortController();
    controllerRef.current = controller;
    return controller;
  }, []);

  const abort = useCallback(() => {
    controllerRef.current?.abort();
    controllerRef.current = null;
  }, []);

  useEffect(() => () => abort(), [abort]);

  return { start, abort };
}
